import React from 'react'
import { StyledButton } from './styled'

export interface IMultiToggleButton {
  children: any
  value?: string | boolean
  onClick?: any
  active?: boolean
  disabled?: boolean
}

export const MultiToggleButton = ({
  children,
  onClick,
  value,
  active,
  disabled,
}: IMultiToggleButton) => (
  <StyledButton
    color="primary"
    variant={active ? 'contained' : 'text'}
    onClick={() => onClick(value)}
    disabled={disabled}
    className={active ? 'auto-selected' : 'auto-not-selected'}
  >
    {children}
  </StyledButton>
)
